import { HttpClient } from "../../../../services/http/http-client";
import { MODIFICATION_URL } from "../../../../services/common-urls";
import { CONTACTS_URL, BOOKING_URL } from "../booking-service";

const CONTACT_RELATION_ID = 'contact_relation_id';
const CONTACT_RELATIONS = 'contact_relations';
const CONTACT_ID = 'contact_id';

const CONTACTS = 'contacts';
const BIRTHDATE = 'birthdate';
const RELATION = 'relation';

const modifyRelatedContact = ({
  key = CONTACT_RELATION_ID,
  kVal,
  name = 'relation',
  value,
  table = CONTACT_RELATIONS
}) => HttpClient.post(MODIFICATION_URL, {
  key,
  kVal,
  name,
  value,
  table,
});

const PASSPORT_NO = 'passport_no';
const SEARCH_MODAL_CONTACTS = 'search_modal_contacts';
const BOTH_STRING = 'both';
const ARTIST = 'artist';
const REMOVE_ARTIST_CONTACT = 'remove_artist_contact';
export const relatedContactService = {
  modifyRelatedContact: modifyRelatedContact,
  
  modifyRelatedContactRelation: ({
    contactRelationId,
    value
  }) => modifyRelatedContact({
    kVal: contactRelationId,
    name: RELATION,
    value
  }),
  modifyRelatedContactBirthdate: ({
    contactId,
    value
  }) => modifyRelatedContact({
    key: CONTACT_ID,
    kVal: contactId,
    name: BIRTHDATE,
    value,
    table: CONTACTS
  }),
  modifyRelatedContactBirthdate: ({
    contactId,
    value
  }) => modifyRelatedContact({
    key: CONTACT_ID,
    kVal: contactId,
    name: PASSPORT_NO,
    value,
    table: CONTACTS
  }),
  searchContacts: ({
    searchString
  }) => HttpClient.get(CONTACTS_URL, {
    action: SEARCH_MODAL_CONTACTS,
    search_str: searchString,
    contact_search_type: BOTH_STRING,
  }),
  deleteContactRelation: ({
    contactRelationId
  }) => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: REMOVE_ARTIST_CONTACT,
    contact_relation_id: contactRelationId
  })
}